<div class="container-fluid pb-3">
    @switch (view().status) {
        @case ('loading') {
            <app-load />
        }
        @case ('notFound') {
            <div class="alert alert-warning" role="alert">
                {{ 'installationProjects_detail_notFound' | translate: 'online' : 'ngonline' }}
            </div>
        }
        @case ('error') {
            <div class="alert alert-danger" role="alert">
                {{ 'installationProjects_error' | translate: 'online' : 'ngonline' }}
            </div>
        }
        @case ('success') {
            @if (project(); as project) {
                <div class="row g-3">
                    <div class="col-12 col-lg-5 col-xxl-4">
                        <div class="card h-100">
                            <div class="card-body">
                                <div class="card-title">
                                    <h5>
                                        {{
                                            'installationProjects_detail_projectInformation'
                                                | translate: 'online' : 'ngonline'
                                        }}
                                    </h5>
                                </div>
                                <ul class="list-group list-group-flush description-list">
                                    <li
                                        class="list-group-item"
                                        app-key-values-row
                                        [label]="
                                            'installationProjects_column_projectId'
                                                | translate: 'online' : 'ngonline'
                                        "
                                        [values]="[project.projectNumber ?? '–']"></li>
                                    <li
                                        class="list-group-item"
                                        app-key-values-row
                                        [label]="
                                            'installationProjects_column_buildingId'
                                                | translate: 'online' : 'ngonline'
                                        "
                                        [values]="[project.buildingNumber ?? '–']"></li>
                                    <li class="list-group-item">
                                        <span class="fw-bold">
                                            {{
                                                'installationProjects_column_status'
                                                    | translate: 'online' : 'ngonline'
                                            }}
                                        </span>
                                        @if (statusDisplay(); as statusDisplay) {
                                            <span class="badge" [class]="statusDisplay.pillClass">
                                                {{
                                                    statusDisplay.labelKey
                                                        | translate: 'online' : 'ngonline'
                                                }}
                                            </span>
                                        }
                                    </li>
                                    <li
                                        class="list-group-item"
                                        app-key-values-row
                                        [label]="
                                            'installationProjects_detail_customer'
                                                | translate: 'online' : 'ngonline'
                                        "
                                        [values]="[project.customerName ?? '–']"></li>
                                    <li
                                        class="list-group-item"
                                        app-key-values-row
                                        [label]="
                                            'installationProjects_column_address'
                                                | translate: 'online' : 'ngonline'
                                        "
                                        [values]="[address()]"></li>
                                    <li
                                        class="list-group-item"
                                        app-key-values-row
                                        [label]="
                                            'installationProjects_column_plannedStart'
                                                | translate: 'online' : 'ngonline'
                                        "
                                        [values]="[
                                            project.plannedStart != null
                                                ? (project.plannedStart | appdate)
                                                : '–',
                                        ]"></li>
                                    <li
                                        class="list-group-item"
                                        app-key-values-row
                                        [label]="
                                            'installationProjects_column_expectedCompletion'
                                                | translate: 'online' : 'ngonline'
                                        "
                                        [values]="[
                                            project.expectedCompletion != null
                                                ? (project.expectedCompletion | appdate)
                                                : '–',
                                        ]"></li>
                                    <li
                                        class="list-group-item"
                                        app-key-values-row
                                        [label]="
                                            'installationProjects_detail_numberOfLocations'
                                                | translate: 'online' : 'ngonline'
                                        "
                                        [values]="[locationTotal()]"></li>
                                    <li
                                        class="list-group-item"
                                        app-key-values-row
                                        [label]="
                                            'installationProjects_detail_projectManager'
                                                | translate: 'online' : 'ngonline'
                                        "
                                        [values]="[project.projectManagerName ?? '–']"></li>
                                    <li
                                        class="list-group-item"
                                        app-key-values-row
                                        [label]="
                                            'installationProjects_detail_salesRepresentative'
                                                | translate: 'online' : 'ngonline'
                                        "
                                        [values]="[project.salesRepresentativeName ?? '–']"></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-7 col-xxl-8">
                        <div class="card mb-3">
                            <div class="card-header">
                                {{
                                    'installationProjects_detail_progress'
                                        | translate: 'online' : 'ngonline'
                                }}
                            </div>
                            <div class="card-body">
                                <div
                                    class="progress mb-3"
                                    role="progressbar"
                                    [attr.aria-valuenow]="progressPercent()"
                                    aria-valuemin="0"
                                    aria-valuemax="100">
                                    <div
                                        class="progress-bar"
                                        [class]="statusDisplay()?.pillClass ?? ''"
                                        [style.width.%]="progressPercent()"></div>
                                </div>
                                <div class="row small">
                                    @for (step of progressSteps(); track step.labelKey) {
                                        <div
                                            class="col text-center progress-step"
                                            [class]="step.state"
                                            [class.fw-bold]="step.state === 'active'"
                                            [class.text-primary]="step.state === 'completed'"
                                            [class.text-muted]="step.state === 'future'">
                                            {{ step.labelKey | translate: 'online' : 'ngonline' }}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div class="row g-3 mb-3">
                            @for (counter of counters(); track counter.labelKey) {
                                <div class="col-6 col-md-3">
                                    <div class="card h-100 text-center">
                                        <div class="card-body">
                                            <div
                                                class="counter-label small text-uppercase text-muted fw-bold">
                                                @if (counter.route != null) {
                                                    <a
                                                        class="stretched-link text-reset text-decoration-none"
                                                        [routerLink]="counter.route">
                                                        {{
                                                            counter.labelKey
                                                                | translate: 'online' : 'ngonline'
                                                        }}
                                                    </a>
                                                } @else {
                                                    {{
                                                        counter.labelKey
                                                            | translate: 'online' : 'ngonline'
                                                    }}
                                                }
                                            </div>
                                            <div
                                                class="counter-value fs-2 fw-bold"
                                                [class]="counter.textClass">
                                                {{ counter.value }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        <div class="card next-visit text-bg-primary">
                            <div class="card-body">
                                <div
                                    class="next-visit-label small text-uppercase fw-bold opacity-75">
                                    {{
                                        'installationProjects_detail_nextVisit'
                                            | translate: 'online' : 'ngonline'
                                    }}
                                </div>
                                @if (project.nextVisit; as nextVisit) {
                                    <div class="next-visit-value fs-5 fw-bold">
                                        {{ nextVisit.date | appdate }}
                                        @if (visitWindow(); as visitWindow) {
                                            &middot; {{ visitWindow }}
                                        }
                                    </div>
                                } @else {
                                    <div class="next-visit-value fs-5 fw-bold">
                                        {{ noVisitMessageKey() | translate: 'online' : 'ngonline' }}
                                        @if (
                                            project.status === 'completed' &&
                                            project.expectedCompletion != null
                                        ) {
                                            &middot; {{ project.expectedCompletion | appdate }}
                                        }
                                    </div>
                                }
                                <a
                                    class="see-locations small link-light"
                                    [routerLink]="locationsTabRoute">
                                    {{
                                        'installationProjects_detail_seeLocations'
                                            | translate: 'online' : 'ngonline'
                                    }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            }
        }
    }
</div>
